// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"60845a4b","99":"dabc12c5","146":"2c970234","175":"908a7284","204":"9d61a5f7","349":"c0605ec6","453":"e9e7ec89","479":"dd049732","655":"f06f06c7","674":"86e8e8cc","768":"e279e88c","813":"2f7f7200","963":"74e5a36f"}[chunkId] + ".chunk.js";
};